import {createAction} from '@reduxjs/toolkit'

import {ErrorCode, ErrorType, SheetErrorAttributeType} from './interfaces'

export const setFailureException = createAction<ErrorType<SheetErrorAttributeType>>('error/setFailureException')
export const addException = createAction<ErrorType<SheetErrorAttributeType>>('error/addException')
export const removeException = createAction<ErrorCode>('error/removeException')
